import classNames from "classnames";
import GAVerifiedContainer from "app/components/React/GAVerifiedIcon/GAVerifiedContainer";
import { dynamicFilterFilter } from "app/filters/dynamicFilter";
import { MarkerInnerWrapper } from "./styledComponents";

export const LegendData = (props) => {
    const { legendItems, toggleSeries, legendContainerClass, colors } = props;
    const legendValue = (item) => item.data && dynamicFilterFilter()(item.data, item.format);

    return (
        <div className={`legend legend-data ${legendContainerClass}`}>
            {legendItems.map((item, index) => {
                return (
                    <div
                        key={index}
                        onClick={() => toggleSeries(item, !!item.hidden)}
                        className={classNames(
                            "legend-item",
                            { "legend-item--off": !!item.hidden },
                            { "legend-item--disabled": item.alwaysDisabled },
                        )}
                    >
                        <div>
                            <MarkerInnerWrapper
                                className="item-marker--flat"
                                color={item.color || item.Color || colors[index]}
                            />
                        </div>
                        <div>
                            <div className={`legend-item-data ${item.dataClass}`}>
                                {legendValue(item)}
                                {item.isGAVerified ? (
                                    <GAVerifiedContainer
                                        size="SMALL"
                                        isActive={true}
                                        isPrivate={item.isGAPrivate}
                                        tooltipAvailable={true}
                                        tooltipIsActive={false}
                                        metric={item.metric}
                                    />
                                ) : null}
                            </div>
                            <div
                                className="item-name"
                                title={item.name || item.Title}
                            >
                                {item.name || item.Title}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
